import React, { useRef } from 'react'
import {
    PageTitleText,FormContainer,PageLinkText,AuthBgContainer,FlexContainer
} from './forget_password.style';

import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn
} from '../../../widget/styledComponents/input_field.style'
import { gql, useMutation } from '@apollo/client';
import { toaster } from 'evergreen-ui';



export const AUTH_FORGET_PASSWORD = gql`
mutation FacilityManager_resetPassword_sendEmail($email: String!) {
  facilityManager_resetPassword_sendEmail(email: $email) {
    code
    success
    error
    token
  }
}
`;


function ForgetPasswordWidget() {

const [verifyLogin, { loading, error }] = useMutation(AUTH_FORGET_PASSWORD);


const handleSubmit = (e)=>{
e.preventDefault();
verifyLogin({
    variables: { 
        email:emailRef.current.value,
    },
    })
    .then((response) => {

        if(response.data['facilityManager_resetPassword_sendEmail']['code']==='200'){
            emailRef.current.value=''
            toaster.success("Reset Password Email sent")
        }
        console.log(response)
    })
    .catch((errorr) => {
        if(error){
            toaster.danger(error)
        }
        toaster.danger(errorr.message)
    });
};
const emailRef = useRef(null);

  return (
    <div className='row'>
        <AuthBgContainer className="col s12 m6 l6 hide-on-med-and-down"></AuthBgContainer>
        <div className='col s12 m6 l6 '>
            <div className='mt-100'></div>
            <form onSubmit={handleSubmit}>
            <FormContainer >
                <PageTitleText>
                    Forget Password
                </PageTitleText>
                <br/><br/>
                
                <InputFieldTitleText>
                    Email Address
                </InputFieldTitleText>
                <AppInputField
                    type="email" 
                    placholder="alijames@gmail.com"
                    ref={emailRef}
                required/> 
               
                <AppInputFieldBtn className="mt-50"  disabled={loading}>
                    Submit
                </AppInputFieldBtn>
                <FlexContainer>
                    Already have an account?
                    <PageLinkText className='right' style={{
                        color:"var(--black, #4F46E5) !important",fontSize:"18px",
                    }} to="/" > Log in</PageLinkText>
                </FlexContainer>
                

            </FormContainer>
            </form>

        </div>
    </div>
  )
}

export default ForgetPasswordWidget